import { render, staticRenderFns } from "./modalMemberFromExternalSource.vue?vue&type=template&id=680b6976&"
import script from "./modalMemberFromExternalSource.vue?vue&type=script&lang=js&"
export * from "./modalMemberFromExternalSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports